import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';

function GlobalSEO () {
  const location = useLocation();
  const baseUrl = "https://historiografija.ba"; 
  const canonicalUrl = `${baseUrl}${location.pathname}`;

  return (
    <Helmet>
      <link rel="canonical" href={canonicalUrl} />
    </Helmet>
  );
};

export default GlobalSEO;
